import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import { AppContext } from "../../../RoundRegContext";
import { useTranslation } from "react-i18next";

const InquiryCategory = ({ card, idx }) => {
    const { t } = useTranslation();
    const { setListByTarget } = useContext(AppContext);

    const handleChange = (e) => {
        setListByTarget({ ...card, title: e.target.value });
    };

    return (
        <>
            <div className="c__form horiz">
                <div className="f__group export-label ">
                    <div className="f__control  ">
                        <input
                            name="InquiryCategory"
                            placeholder={"카테고리를 입력하세요"}
                            type="text"
                            className={`c__input f__item`}
                            value={card.title}
                            onChange={handleChange}
                            required={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default InquiryCategory;
